import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";
import {createSelector} from "@ngrx/store";
import * as _ from 'lodash'

const selectLogiDashboardsDetailsFeature = (state: IgenomicsState) => state.analytics;

export const logiDashboardsDetailsSelector =
  createSelector(selectLogiDashboardsDetailsFeature, selectLogiDetailsFeature =>
    _.cloneDeep(selectLogiDetailsFeature.logiDashboardsDetails))
